import axios from 'axios';

const AdditionalInfoApi = axios.create({
  baseURL: process.env.VUE_APP_TEST,
});

export default AdditionalInfoApi;
